import { CenterSpinner } from "components/CenterSpinner";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const MainRedirector: React.FC<{}> = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/global/stats");
  }, [navigate]);

  return <CenterSpinner size="large" />;
};
